// pages/admin/components/AdminPagination.js
import React from 'react';

const AdminPagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const getVisiblePages = () => {
    const pages = new Set();
    
    // Always include first and last page
    pages.add(1);
    pages.add(totalPages);
    
    // Include current page and surrounding pages
    pages.add(currentPage);
    if (currentPage > 1) pages.add(currentPage - 1);
    if (currentPage < totalPages) pages.add(currentPage + 1);
    
    return Array.from(pages).sort((a, b) => a - b);
  };

  const visiblePages = getVisiblePages();

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      onPageChange(page);
    }
  };

  const renderPageButton = (page, index) => {
    const prevPage = index > 0 ? visiblePages[index - 1] : null;
    const showEllipsis = prevPage && page > prevPage + 1;

    return (
      <React.Fragment key={page}>
        {showEllipsis && (
          <span className="admin-pagination-ellipsis">...</span>
        )}
        <button
          className={`admin-btn-page ${page === currentPage ? 'active' : ''}`}
          onClick={() => handlePageChange(page)}
        >
          {page}
        </button>
      </React.Fragment>
    );
  };

  return (
    <div className="admin-pagination">
      <button
        className={`admin-btn-page ${currentPage === 1 ? 'disabled' : ''}`}
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <i className="fas fa-chevron-left"></i>
      </button>

      {visiblePages.map(renderPageButton)}

      <button
        className={`admin-btn-page ${currentPage === totalPages ? 'disabled' : ''}`}
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <i className="fas fa-chevron-right"></i>
      </button>
    </div>
  );
};

export default AdminPagination;